import getDevice from './module/getDevice.js'
import functions from './functions.js' // Activamos functions si no usamos Barba.js
import { initTextClipAnimations, clipBox } from './module/gsap.js'
import pageTransition from './module/page-transition.js'

/* ///////////////////////////////////////////////////////////////////// */
/* /////////////////////////// DEVICE DATA ///////////////////////////// */
/* ///////////////////////////////////////////////////////////////////// */

const deviceData = getDevice()

/* Ejecutar el getDevice si cambia el tamaño del navegador o rota el dispositivo */
window.addEventListener('resize', getDevice)
window.addEventListener('orientationchange', getDevice)

/* ///////////////////////////////////////////////////////////////////// */
/* /////////////////////////////// EXEC //////////////////////////////// */
/* ///////////////////////////////////////////////////////////////////// */

document.addEventListener('DOMContentLoaded', function () {
  functions(deviceData)
  initTextClipAnimations()
  clipBox()
  pageTransition()
})
